import { fetchWithEnvelope, setHeaderOptions } from "#/api/apiHelpers";

export type MediaItem = {
  id: string;
  url: string;
  name: string | null;
  slug: string | null;
  image_type: string | null;
  subject: string | null;
  prompt: string | null;
  url_match: string | null;
  insert_regex: string | null;
  relevant_text: string | null;
  content_id: string | null;
  content_section_id: string | null;
  diagnosis_id: string | null;
  is_active: boolean | null;
  has_embedding?: boolean | null;
  created_at: string | null;
  updated_at: string | null;
};

export type MediaSearchParams = {
  context?: "blog" | "site" | "marketing" | "content" | "general";
  q?: string;
  page?: number;
  limit?: number;
};

export type MediaSearchResponse = {
  data: MediaItem[];
  page: number;
  limit: number;
  total: number;
};

type MediaSearchEnvelope = {
  data: MediaItem[];
  page?: number;
  limit?: number;
  total?: number;
  error?: string | null;
};

export async function searchMedia(
  params: MediaSearchParams
): Promise<MediaSearchResponse> {
  const searchParams = new URLSearchParams();

  if (params.context) {
    searchParams.set("context", params.context);
  }

  if (params.q) {
    searchParams.set("q", params.q);
  }

  if (params.page) {
    searchParams.set("page", params.page.toString());
  }

  if (params.limit) {
    searchParams.set("limit", params.limit.toString());
  }

  const queryString = searchParams.toString();
  const slug = `/media${queryString ? `?${queryString}` : ""}`;
  const options = await setHeaderOptions({ method: "GET" });

  const response = await fetchWithEnvelope<MediaSearchEnvelope>(slug, options);

  const items = Array.isArray(response.data)
    ? response.data
    : Array.isArray((response.data as { data?: MediaItem[] } | undefined)?.data)
    ? ((response.data as { data?: MediaItem[] }).data ?? [])
    : [];

  return {
    data: items,
    page: response.page ?? params.page ?? 1,
    limit: response.limit ?? params.limit ?? 20,
    total:
      response.total ??
      (typeof (response.data as { total?: number } | undefined)?.total ===
      "number"
        ? (response.data as { total?: number }).total ?? items.length
        : items.length),
  };
}
